import React from "react";
import { LuChevronDown } from "react-icons/lu";

export const KeyAspects = ({ data, setData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      keyAspects: { ...prev.keyAspects, [name]: value },
    }));
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#CBF0D0] w-4 h-4 rounded" />
        <h1>Key Aspects</h1>
      </div>

      <div className="py-4 grid md:grid-cols-2 gap-4">
        <div className="">
          <label htmlFor="" className="">
            No. Of Screens
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <input
              value={data.keyAspects?.screen || ""}
              onChange={handleChange}
              name="screen"
              type="text"
              placeholder="e.q 56"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>
        <div className="relative w-full">
          <label htmlFor="" className="">
            Industry
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <select
              value={data.keyAspects?.industry || ""}
              onChange={handleChange}
              name="industry"
              className="custom-select w-full bg-transparent p-2"
            >
              <option value="" className="opacity-60">
                e.q Food & Drink
              </option>
              <option value="food">Food</option>
              <option value="drink">Drink</option>
              <option value="tech">Tech</option>
            </select>
            <LuChevronDown className='text-xl  absolute right-2 top-[45px]'/>
          </div>
        </div>
     

        <div className="">
          <label htmlFor="" className="">
            Themes
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <input
             value={data.keyAspects?.themes || ""}
             onChange={handleChange}
             name="themes"
              type="text"
              placeholder="e.q Light, Dark, Neobrutalism"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>

        <div className="">
          <label htmlFor="" className="">
            User Flows
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <input
             value={data.keyAspects?.flows || ""}
             onChange={handleChange}
             name="flows"
              type="text"
              placeholder="12"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
